module.exports = __webpack_public_path__ + "static/img/siemenpuu-foundation.59775faf.png";